module.exports = __webpack_public_path__ + "static/media/hw.1d92c792.svg";